import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const zebraPrintFile = createAsyncThunk('zebraPrinter/printFile',
  async ({ file, order_id: id, esId }, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/zebra/printFile', { file, order_id: id, es_id: esId });
      return data;
    } catch (error) {
      return rejectWithValue(`${error?.message} ${error?.info || ''}`);
    }
  });

export const clearZebraPrintFile = createAction('clearZebraPrintFile');
export default zebraPrintFile;
